import React, { useEffect, useState } from 'react'
import Submenu from '../../UI/menu/submenu/Submenu'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const SubmenuPacks = () => {

    const [list, setList] = useState([])

    useEffect(() => {
        setMenu()
    }, [])

    const setMenu = () => {
        const listTemp = []

        listTemp.push({
            url: '/production/packs',
            name: 'Партії',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })
        listTemp.push({
            url: '/production/add-good-in-pack',
            name: 'Додати товар в партію',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })

        setList(listTemp)
    }
    
  return (
    <Submenu 
        list={list}
    />
  )
}

export default SubmenuPacks